// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"95172a27","453":"cece4f5f","732":"82363a98"}[chunkId] + ".chunk.js";
};